/**
 * Encodes one `(folder, key)` pair into a FileSystem field-mask path. Per the
 * UpdateFileSystem proto contract, dots in `key` are escaped to `\.`; slashes
 * are normal characters. An empty `key` returns just the folder, which the
 * proto interprets as "replace the whole map".
 *
 * `key` must be a raw, unescaped string — passing a key that has already been
 * through this encoder will double-escape its dots.
 */
export const encodeFieldMaskPath = (folder, key) => {
  if (!key) {
    return folder;
  }
  const escapedKey = key.replace(/\./g, '\\.');
  return `${folder}.${escapedKey}`;
};
//# sourceMappingURL=fieldMask.js.map